export default {
  root: () => ({
    class: [
      'relative flex'
    ]
  }),
  content: 'overflow-x-auto overflow-y-hidden scroll-smooth overscroll-x-contain overscroll-y-auto [&::-webkit-scrollbar]:hidden grow w-full',
  tabList: ({ props }) => ({
    class: [
      'relative flex',
      // 'border-solid border-b border-t border-surface-0 dark:border-surface-0',
      {
        'justify-center': props.ptOptions?.variant === 'stretch'
      }
    ]
  }),
  nextButton: '!absolute top-0 right-0 z-20 h-full w-10 flex items-center justify-center text-surface-700 dark:text-surface-0/80 bg-surface-0 dark:bg-surface-900 outline-transparent cursor-pointer shrink-0 transition-all opacity-50 hover:opacity-100',
  prevButton: '!absolute top-0 left-0 z-20 h-full w-10 flex items-center justify-center text-surface-700 dark:text-surface-0/80 bg-surface-0 dark:bg-surface-900 outline-transparent cursor-pointer shrink-0 transition-all opacity-50 hover:opacity-100',
  activeBar: 'z-10 block absolute h-[2px] bottom-0 bg-primary transition-all'
}